import React, { useState } from "react";
import "./newTooltip.css";

type TTolltipProp = {
  value: string;
  option: any;
  truncated?: boolean;
  placement?: string;
  className?: string;
};

const MasterCustomTooltip = ({ value, option, truncated, className = "" }: TTolltipProp) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div className={`position-relative d-inline-block ${className}`}>
      {/* Tooltip Icon */}
      <i 
        className="fas fa-info-circle text-muted cursor-pointer"
        style={{ 
          fontSize: '16px',
          cursor: 'pointer',
       
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      
      {/* Tooltip Content */}
      {showTooltip && (
        <div 
          className="position-absolute bg-dark text-white p-2 rounded shadow-lg"
          style={{
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '5px',
            zIndex: 1060,
            minWidth: '300px',
            maxWidth: '900px',
            fontSize: '12px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {value}
          {/* Tooltip Arrow */}
          <div 
            className="position-absolute"
            style={{
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: '5px solid #000'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MasterCustomTooltip;